export default class FormName {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.name = rawData.name
      this.displayName = rawData.displayName
    }
  }